import { SagaIterator } from 'redux-saga';
import { UserFormData } from 'src/modules/common/types/UserFormData';
import { PROFILE_SYNC_PERFORM } from 'src/modules/profile/actions/ProfileActions';
import { waitProfileSynchronization } from 'src/modules/profile/sagas/utils/waitProfileSynchronization';
import { call, put } from 'typed-redux-saga';

export function* syncProfileForeground(
  form: UserFormData,
): SagaIterator<UserFormData> {
  yield* put(PROFILE_SYNC_PERFORM.request('foreground', form));
  return yield* call(waitProfileSynchronization);
}
